export const formatDate = (date, isEndDate) => {
  let formattedDate =
    date.getUTCFullYear() +
    '-' +
    (date.getUTCMonth() + 1) +
    '-' +
    date.getUTCDate();

  if (isEndDate) {
    date.setHours(23);
    date.setMinutes(59);
    date.setSeconds(59);
  }

  let formattedTime =
    date.getUTCHours() +
    ':' +
    date.getUTCMinutes() +
    ':' +
    date.getUTCSeconds();

  return `${formattedDate} ${formattedTime}`;
};

export const formatDateToString = (date) => {
  return (
    date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
  );
};

export const formatDateToLocaleString = (date) => {
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  return date.toLocaleDateString('de-DE', options);
};
